import { Link } from "react-router-dom";
import { ArrowUp } from "lucide-react";
import { scrollToId } from "./SmoothScroll";
import { PHONE_DISPLAY, PHONE_TEL } from "../lib/site";

const AREAS = ["Bonsall", "Matlock", "Matlock Bath", "Cromford", "Wirksworth", "Bakewell", "Darley Dale", "Belper"];

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-line bg-coal-800">
    <div className="px-5 pb-10 pt-16 md:px-12 md:pt-24">
      <div className="grid gap-12 md:grid-cols-12">
        <div className="md:col-span-5">
          <p className="font-display text-6xl uppercase leading-[0.85] tracking-tight text-white md:text-8xl">
            MG<span className="text-ember">&</span>D
          </p>
          <p className="mt-5 max-w-xs text-sm leading-relaxed text-steel">
            Groundworks & drainage done properly — by our own crew, with our own
            kit, from our base in Bonsall, Derbyshire.
          </p>
        </div>
        <div className="md:col-span-3">
          <p className="mb-5 font-mono text-[10px] uppercase tracking-[0.25em] text-ember">Contact</p>
          <p className="mb-2 font-mono text-[11px] uppercase tracking-[0.15em] text-steel">Mr J Fox — Proprietor</p>
          <a href={`tel:${PHONE_TEL}`} data-testid="footer-phone-link" className="block font-mono text-sm tracking-[0.1em] text-white transition-colors hover:text-ember">
            {PHONE_DISPLAY}
          </a>
          <p className="mt-3 font-mono text-[11px] uppercase tracking-[0.15em] text-steel">Mon–Sat · 7:30–17:30</p>
        </div>
        <div className="md:col-span-3">
          <p className="mb-5 font-mono text-[10px] uppercase tracking-[0.25em] text-ember">Areas covered</p>
          <ul className="space-y-2 font-mono text-[11px] uppercase tracking-[0.15em] text-steel">
            {AREAS.map((a) => (
              <li key={a} className="flex items-center gap-2">
                <span className="h-1 w-1 bg-ember" aria-hidden="true" /> {a}
              </li>
            ))}
          </ul>
        </div>
        <div className="flex md:col-span-1 md:justify-end">
          <button
            data-testid="footer-back-to-top"
            onClick={() => scrollToId("#top")}
            aria-label="Back to top"
            className="flex h-11 w-11 items-center justify-center border border-line text-steel transition-colors duration-300 hover:border-ember hover:text-ember"
          >
            <ArrowUp size={16} />
          </button>
        </div>
      </div>
    </div>
    <div className="flex flex-col gap-3 border-t border-line px-5 py-5 font-mono text-[10px] uppercase tracking-[0.2em] text-steel sm:flex-row sm:items-center sm:justify-between md:px-12">
      <p>© 2026 Matlock Groundworks & Drainage</p>
      <Link to="/admin" data-testid="footer-admin-link" className="transition-colors hover:text-ember">
        Admin
      </Link>
    </div>
  </footer>
);
